import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import rankEquity from './views/rank-equity'
import rankEquityDetails from './views/rank-equity-details'

export default [
  {
    path: RoutePathConstants.RANK_EQUITY,
    name: 'rankEquity',
    component: rankEquity
  },
  {
    path: RoutePathConstants.RANK_EQUITY_DETAILS,
    name: 'rankEquityDetails',
    component: rankEquityDetails
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/rank-equity/routers.js